"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxErrorPopup = void 0;
const React = __importStar(require("react"));
require("./styles.scss");
const hooks_1 = require("@app/store/hooks");
const popup_1 = require("@shared-modules/components/popup");
const react_1 = require("react");
const reducer_1 = require("@app/store/external/application/reducer");
const icons_1 = require("@shared-modules/components/icons");
const button_1 = require("@shared-modules/components/button");
const toast_1 = require("@shared-modules/components/toast");
const clipboard_hooks_1 = __importDefault(require("@shared-modules/utils/hooks/clipboard.hooks"));
const translation_hooks_1 = require("@hooks/translation.hooks");
const TxErrorPopup = () => {
    const { interactionMode, interactionText } = (0, hooks_1.useAppSelector)(({ application: { interactionMode, interactionText } }) => ({ interactionMode, interactionText }));
    const [isPopupOpened, togglePopup] = (0, react_1.useState)(false);
    const [toastRefresher, refreshToast] = (0, react_1.useState)();
    const translator = (0, translation_hooks_1.useComponentTranslation)("txErrorPopup");
    (0, react_1.useEffect)(() => {
        if (interactionMode === reducer_1.Interactions.error) {
            togglePopup(true);
        }
    }, [interactionMode]);
    const [, copy] = (0, clipboard_hooks_1.default)();
    const copyErrorHandler = () => {
        refreshToast({});
        copy(interactionText || translator("defaultError"));
    };
    return (React.createElement(popup_1.Popup, { isOpened: isPopupOpened, onClose: () => togglePopup(false) },
        React.createElement("div", { className: "c-tx-error-popup" },
            React.createElement(icons_1.AlertIcon, { scale: 3 }),
            React.createElement("div", { className: "c-tx-error-popup__title" }, translator("title")),
            React.createElement("div", { className: "c-tx-error-popup__message" }, interactionText || translator("defaultError")),
            React.createElement("div", { className: "c-tx-error-popup__buttons" },
                React.createElement(toast_1.Toast, { refresher: toastRefresher, text: translator("copyHelpLabel") },
                    React.createElement(button_1.Button, { onClick: copyErrorHandler, type: "thirtery" }, translator("copyButton"))),
                React.createElement(button_1.Button, { onClick: () => togglePopup(false), type: "secondary" }, translator("closeButton"))))));
};
exports.TxErrorPopup = TxErrorPopup;
